import { FLIGHT_ART } from "./flight-art.js";

/** Decorative illustration using the same WebP sprites as the live game. */
export function FlightPreview() {
  return <div className="nf-flight-preview nf-illustrated-preview" aria-hidden="true">
    <img className="nf-preview-background" src={FLIGHT_ART.panorama} alt="" decoding="async" />
    <div className="nf-preview-course">
      <img className="nf-preview-column nf-preview-column-top" src={FLIGHT_ART.column} alt="" />
      <img className="nf-preview-column nf-preview-column-bottom" src={FLIGHT_ART.column} alt="" />
      <img className="nf-preview-pumpkin" src={FLIGHT_ART.pumpkin} alt="" />
    </div>
    <img className="nf-preview-witch nf-preview-witch-art" src={FLIGHT_ART.witch} alt="" decoding="async" />
  </div>;
}
